
import React from 'react';

// Empty component that returns null to completely disable this floating button
const FloatingUpgradeButton: React.FC = () => {
  return null;
};

export default FloatingUpgradeButton;
